import { App } from '@capacitor/app'
import * as LiveUpdates from '@capacitor/live-updates'
import { Network } from '@capacitor/network'

export default defineNuxtPlugin(async () => {
  const isNative = useIsNative()
  const { $sentry } = useNuxtApp()

  if (!process.client || !isNative) {
    return
  }

  const checkNetworkAndSync = async () => {
    try {
      const networkStatus = await Network.getStatus()
      if (!networkStatus.connected) {
        return
      }

      const result = await LiveUpdates.sync()
      if (result?.activeApplicationPathChanged) {
        await LiveUpdates.reload()
      }
    } catch (error) {
      console.error('Live updates error:', error)
      $sentry.captureException(error)
    }
  }

  try {
    Network.addListener('networkStatusChange', async status => {
      if (status.connected) {
        await checkNetworkAndSync()
      }
    })

    App.addListener('resume', async () => {
      await checkNetworkAndSync()
    })

    await checkNetworkAndSync()
  } catch (error) {
    console.error('Failed to initialize live updates:', error)
    $sentry.captureException(error)
  }
})
